import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Report } from '../../models/report.model';
import { PhotoService } from '../../services/photo.service';

@Component({
  selector: 'app-photographies',
  templateUrl: './photographies.component.html',
  styleUrls: ['./photographies.component.scss'],
})
export class PhotographiesComponent implements OnChanges {
  @Input() photographies!: Report.Photographs;
  @Input() reportId!: string;
  @Input() isLoading = false;

  photographiesInternal!: Report.Photographs;
  photographiesBinaries: string[] = [];
  cancelModal = false;

  @Output() photographiesChanged = new EventEmitter<Report.Photographs>();
  @Output() photographiesEnabled = new EventEmitter<boolean>();
  @Output() cancled = new EventEmitter<void>();

  constructor(private readonly photoService: PhotoService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.changes(changes);
  }

  private async changes(changes: SimpleChanges) {
    if (
      changes['reportId']?.currentValue ||
      changes['photographies']?.currentValue
    ) {
      if (this.photographies?.photographs?.length) {
        const updatedPhotos = await Promise.all(
          this.photographies.photographs.map(async (photo) => {
            if (photo.index !== undefined) {
              const updatedPhoto = await this.photoService.getPhotography(
                this.reportId,
                photo.index,
              );
              return { ...photo, photo: updatedPhoto };
            }
            return photo;
          }),
        );
        this.photographies = {
          ...this.photographies,
          photographs: updatedPhotos,
        };
      }
    }
    this.photographiesInternal = structuredClone(this.photographies);
  }

  photographiesSectionChanged(photographies: Report.Photographs): void {
    this.photographiesInternal = {
      ...photographies,
      photographs: [...photographies.photographs.filter((p) => p.photo)],
    };
  }

  onClearPhoto(index: number) {
    this.photographiesInternal.photographs =
      this.photographiesInternal.photographs.filter(
        (photo) => photo.index !== index,
      );
    this.photographiesInternal = { ...this.photographiesInternal };
  }

  onSaveSection(): void {
    this.photographiesChanged.emit(this.photographiesInternal);
  }

  onEnabled(isEnabled: boolean): void {
    this.photographiesEnabled.emit(isEnabled);
  }

  onCancled(): void {
    this.photographiesInternal = structuredClone(this.photographies);
    this.cancelModal = !this.cancelModal;
  }
}
